import { render, staticRenderFns } from "./view-photos.vue?vue&type=template&id=2a6baaa3&scoped=true&lang=pug"
import script from "./view-photos.vue?vue&type=script&lang=js"
export * from "./view-photos.vue?vue&type=script&lang=js"
import style0 from "./view-photos.vue?vue&type=style&index=0&id=2a6baaa3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6baaa3",
  null
  
)

export default component.exports